<template>
  <div class="headercontent">
    <div class="contents">
      <!-- 登录后 -->
      <span
        v-if="this.$store.state.userName"
        class="widback"
      >
        <span class="pgo">
          <img
            src="../assets/img/login/user.png"
            alt=""
            style="vertical-align:middle;margin-right:8px;width:13px;"
          >
          <span class="namesty">
            {{ this.$store.state.userName | nameslip }}
          </span>
          <img
            src="../assets/img/login/down.png"
            alt=""
            style="vertical-align:middle;margin-left:8px;width:14px;"
          >
        </span>
        <p class="user_inlog">
          <ul>
            <li
              class="los"
              v-for="(item, i) in $t('navbar.list')"
              :key="i"
              @click="handleDrop(item.type)"
            >
              <img
                :src="item.img"
                alt=""
                style="vertical-align:middle;margin-right:6px;width:16px;"
              >
              {{item.name}}
            </li>
          </ul>
        </p>
      </span>

      <span
        class="chiese"
        v-if="this.$store.state.userName"
        @click="handleLanguage"
      >
      {{chinese}}
      </span>
      <!-- 登录前 -->
      <span v-else>
        <span
          class="chiese"
          @click="handleLanguage"
        >
          {{chinese}}
        </span>
        <span>&nbsp; | &nbsp;</span>
        <span
          style="cursor:pointer;color: #cccccc;font-size:14px;"
          @click="loginTap"
        >
          {{$t('navbar.login')}}
        </span>
        <span> &nbsp; | &nbsp;</span>
        <span
          class="jtgreens"
          style="cursor:pointer;font-size:14px;"
          @click="signtap"
        >
          {{$t('navbar.register')}}
        </span>
      </span>
      <!-- 退出登录 -->
      <el-dialog
        :title="$t('loginout.title')"
        :visible.sync="centerDialogVisible"
        width="25%"
        top="20vh"
        center
      >
        <div style="text-align:center;font-size:18px;color:#1d5a33;">{{$t('loginout.out')}}</div>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="centerDialogVisible = false">{{$t('loginout.cancel')}}</el-button>
          <el-button
            type="success"
            @click="loginout"
          >{{$t('loginout.bind')}}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    needFixed: Boolean
  },
  data() {
    return {
      shows: false,
      centerDialogVisible: false,
      lang:'en',
      chinese:"English"
    };
  },
  filters: {
    nameslip(value) {
      if (!value) return "";
      if (value.length > 6) {
        return value.slice(0, 6) + "...";
      }
      return value;
    }
  },
  mounted(){
    var chinese = localStorage.getItem('chinese');
    if(chinese) {
      this.chinese = chinese;
    }else {
      this.chinese = this.chinese;
    }
  },
  methods: {
    mouseOver() {
      this.shows = true;
    },
    mouseMove() {
      this.shows = false;
    },
    handleDrop(type) {
      if (type == 1) {
        this.$router.push({
          name: "user"
        });
      }
      if (type == 3) {
        this.centerDialogVisible = true;
      }
    },
    signtap() {
      this.$router.push({
        name: "sign"
      });
    },
    handleLanguage() {
      console.log(2222);
      if(this.chinese=='English') {
       this.chinese='中文';
       localStorage.setItem("chinese", this.chinese);
        localStorage.setItem("language", this.lang);
        this.$i18n.locale = this.lang;
        this.$router.go(0);
      }else{
        this.chinese='English';
         localStorage.setItem("chinese", this.chinese);
        localStorage.setItem('language','zh');
        this.$i18n.locale='zh';
        this.$router.go(0);
      }
     
    },
    loginTap() {
      this.$router.push({
        name: "login"
      });
    },
    loginout() {
      this.$store.commit("loginOut");
      this.$router.push({
        name: "login"
      });
    }
  }
};
</script>
<style lang="scss">
.headercontent {
  width: 100%;
  height: 40px;
  margin: auto;
  line-height: 40px;
  box-sizing: border-box;
  background-color: #011801;
  .el-popover--plain {
    padding: 0 !important;
  }
  .contents {
    width: 1200px;
    margin: 0 auto;
    text-align: right;

    .widback {
      min-width: 84px;
      height: 40px;
      display: inline-block;
      background-color: #011801;
      text-align: left;
      position: relative;
      cursor: pointer;
      padding: 0 10px;
      span {
        font-size: 14px;
        color: #cccccc;
      }
      .pgo:hover {
        min-width: 84px;
        height: 40px;
        background-color: #011801;
        text-align: left;
        color: #cccccc;
        display: inline-block;
      }
      .pgo {
        min-width: 84px;
        height: 40px;
        display: inline-block;
        background-color: #011801;
        text-align: left;
        color: #cccccc;
        cursor: pointer;
      }
    }
    .user_inlog {
      display: none;
    }
    .widback:hover .user_inlog {
      display: block;
      min-width: 84px;
      padding: 0 10px;
      display: block;
      text-align: left;
      position: absolute;
      top: 40px;
      left: 0px;
    }
    .user_inlog {
      padding: 0 10px;
      min-width: 84px;
      cursor: pointer;
      color: #cccccc;
      text-align: left;
      z-index: 999999;
      background-color: #011801;
      opacity: 0.9;
      li {
        color: #cccccc;
      }
      li:hover {
        color: #248f47;
      }
    }
    .chiese {
      width: 60px;
      height: 40px;
      line-height: 40px;
      display: inline-block;
      cursor: pointer;
      font-size: 14px;
      color: #cccccc;
      text-align: center;
    }
    .chiese:hover {
      color: #248f47;
    }
  }
}
</style>
